import Backbone from 'backbone';
import {formatNumber} from 'common/formatters/number-formatter';
import odometer from 'odometer';

const OdometerView = Backbone.View.extend({
  initialize(options) {
    this.systemName = options.systemName;
  },

  render() {
    const results = this.collection.getResults(this.systemName);
    const total = results[this.systemName].total;
    const formatted = formatNumber(total);
    odometer({el: this.el});
    this.$el.text(formatted);
  },
});

export default OdometerView;
